import React from 'react';
import { Carousel } from 'react-bootstrap';
import { injectInstructionalFeed } from '../InstructionalFeed';
import { injectIntl } from 'react-intl';
import ImageItem from './ImageItem';
import ContentItem from './ContentItem';
import {
  PAGES_PER_SECTION,
  SECTION_IMAGE,
  SECTION_IMAGE_AUTHOR
} from './constants';

@injectInstructionalFeed
@injectIntl
export default class CarouselBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = { index: 0, direction: null };
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  };

  componentDidMount() {
    const tourButton = document.getElementById('take-tour-btn');

    if (PAGES_PER_SECTION[this.props.section] > 1 && tourButton != null)
      document.getElementById('take-tour-btn').style.visibility = 'hidden';

    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(nextProps, prevState) {
    if (prevState.index != this.state.index) {
      const tourButton = document.getElementById('take-tour-btn');

      if (tourButton != null)
        tourButton.style.visibility =
          this.state.index == PAGES_PER_SECTION[nextProps.section]
            ? 'visible'
            : 'hidden';
    }
  }

  handleKeyDown = event => {
    const VALID_KEYS = ['ArrowLeft', 'ArrowRight', 'Enter'];
    if (!VALID_KEYS.includes(event.key)) return;

    if (
      event.key == 'Enter' &&
      document.getElementById('take-tour-btn').style.visibility == 'visible'
    ) {
      document.getElementById('take-tour-btn').click();
      return;
    }

    const className = `carousel-control ${
      event.key === 'ArrowLeft' ? 'left' : 'right'
    }`;
    const value = document.getElementsByClassName(className)[0];
    if (value !== undefined) value.click();
  };

  render() {
    const { section, intl } = this.props;

    return (
      <Carousel
        activeIndex={this.state.index}
        direction={this.state.direction}
        defaultActiveIndex={0}
        onSelect={this.handleSelect}
        indicators={false}
        wrap={false}
      >
        <Carousel.Item>
          <ImageItem
            image={SECTION_IMAGE[section]}
            author={SECTION_IMAGE_AUTHOR[section]}
            title={intl.formatMessage({ id: `${section}_title` })}
            description={intl.formatMessage({ id: `${section}_short` })}
          />
        </Carousel.Item>

        {[...Array(PAGES_PER_SECTION[section]).keys()].map(k => (
          <Carousel.Item key={k}>
            <ContentItem section={section} page={k + 1} />
          </Carousel.Item>
        ))}
      </Carousel>
    );
  }
}
